import { Interpolation } from '@emotion/react';
import { reactNodeTextContent, Text, Theme } from '@lbcamden/lib-react';
import { FunctionComponent, ReactNode } from 'react';

import {
  SectionContainerRoot,
  SectionContent,
  SectionHeader,
  HeaderContent,
} from './SectionContainer.styled';

export type SectionContainerProps = {
  id?: string;
  css?: Interpolation<Theme>;
  className?: string;
  title: ReactNode;
  headerActions?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
};

export const SectionContainer: FunctionComponent<SectionContainerProps> = ({
  title,
  headerActions,
  description,
  children,
  ...props
}) => (
  <SectionContainerRoot data-testid={`section - ${reactNodeTextContent(title)}`} {...props}>
    <SectionHeader>
      <HeaderContent>
        <Text variant="h2">{title}</Text>
        {description && <Text>{description}</Text>}
      </HeaderContent>
      {headerActions}
    </SectionHeader>
    <SectionContent>{children}</SectionContent>
  </SectionContainerRoot>
);
